import React from "react";
import { pure } from "recompose";
import { defineMessages, FormattedMessage } from "react-intl";
import styled from "styled-components";
import Dropdown, { DropdownItem } from "~/components/Dropdown/Dropdown";
import { MoreVertIcon } from "../../../../theme/assets";

const msgs = defineMessages({
  promotions: {
    id: "buttonbar.advantages",
    description: "Advantages",
    defaultMessage: "Advantages",
  },
  availability: {
    id: "buttonbar.availability",
    description: "Availability",
    defaultMessage: "Availability",
  },
  map: {
    id: "buttonbar.map",
    description: "Map",
    defaultMessage: "Map",
  },
});

const DropdownStyled = styled(Dropdown)`
  width: 100%;

  .Dropdown--Header {
    width: 100%;
    padding: 0 !important;
  }

  .Dropdown--Header > :first-child {
    width: 100%;
  }

  .Dropdown--Overlay {
    box-shadow: 2px 0px 4px -4px rgba(0, 0, 0, 0.75), 3px 0px 4px -4px rgba(0, 0, 0, 0.75),
      0px 3px 4px -4px rgba(0, 0, 0, 0.75) !important;
    margin: 4px 0 0 0 !important;
    min-width: 200px;
    max-width: 300px;
    border: 1px solid #e1e1e1 !important;
    color: #908f96;
    font-weight: bold;
  }

  .Dropdown--Overlay > * {
    padding: 10px 15px !important;
  }

  .Dropdown--Overlay > *:not(:last-child):after {
    width: 84% !important;
    left: 7% !important;
  }
`;

const MoreVertIconStyled = styled(MoreVertIcon)`
  svg {
    width: 20px;
    height: 20px;
  }
`;

const ItemStyled = styled.div`
  display: flex;
`;

const IconStyled = styled.div`
  margin-right: 10px;
`;

function DisplayElementsList({ elements, keyActiveDisplayElement }) {
  return (
    <DropdownStyled
      value={keyActiveDisplayElement >= 0 ? keyActiveDisplayElement : null}
      onChange={key => elements[key].handleClick()}
      className="wbkv9-Dropdown-ButtonBarMore"
      isMobile
      label={<MoreVertIconStyled />}
      placement="bottom-end"
      hideArrow>
      {elements &&
        elements.map((element, key) => {
          return (
            <DropdownItem key={key} value={key}>
              <ItemStyled>
                {element.icon && <IconStyled>{element.icon}</IconStyled>}
                {(msgs[element.label] && <FormattedMessage {...msgs[element.label]} />) ||
                  element.label}
              </ItemStyled>
            </DropdownItem>
          );
        })}
    </DropdownStyled>
  );
}

export default pure(DisplayElementsList);
